import { useContext } from "react";
import { DeliveryFoodContext } from "../../../../DeliveryFoodContext";
import { DeliveryFoodItemCommissaryCell } from "../../../../types/DeliveryFoodTypes";
import DeliveryFoodCell from "../../DeliveryFoodCell";

export const DeliveryFoodItemCommissaryPrepForDeliveryCell = ({
    config,
}: {
    config: DeliveryFoodItemCommissaryCell;
}) => {
    const { deliveryFoodState } = useContext(DeliveryFoodContext);
    const { commissary, index, ingredient } = config;

    if (deliveryFoodState.mode.display.COM.prepForDelivery === false) {
        return null;
    }

    const key = `prep-for-delivery-cell-${index}`;
    const commissaryId: string | number = commissary.data?.id || "";

    if (!commissaryId) {
        return null;
    }

    if (!ingredient.results.COM) {
        return null;
    }

    const summary = ingredient.results.COM.prepForDelivery;

    if (!summary) {
        return null;
    }

    return (
        <DeliveryFoodCell
            key={key}
            fieldName={"prepForDelivery"}
            styleName={"PREP_FOR_DELIVERY"}
            summary={summary}
            index={index}
            ingredient={ingredient}
            restaurant={commissary}
        />
    );
};
